import {
  Button,
  Form,
  Space,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Table,
  TimePicker,
  Card,
} from "../../component/antdImports";
import "./style.css";
import Cookies from "universal-cookie";
import { useState, useEffect } from "react";
import {
  url_add_note_cv,
  url_del_cv_interview,
  url_detail_cv_interview,
  url_get_detail_cv,
  url_get_detail_interview,
} from "../../../constants";
import { authAxios } from "../../../utils";
import moment from "moment";
import {
  SearchOutlined,
  EyeOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import ModalEditCandidate from "../candidateManagement/editCandidate/index";

import { useSelector } from "react-redux";
import { openNotificationWithIcon } from "../../Function";
import NotPermission from "../../notPermission";
import ModalDeleteCVInterview from "./ModalDeleteCVInterview";

const { Option } = Select;
const cookies = new Cookies();
const dateFormat = "DD/MM/YYYY";

const getColumns = (
  dataViewInverview,
  handleClickOpenEdit,
  user_handling_permission,
  handleOKTimeCV
) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    align: "center",
    className: "vertical-middle",
    width: 80,
    render: (value, item, index) => index + 1,
  },
  {
    title: "Họ Và Tên",
    dataIndex: "first_name",
    key: "first_name",
    className: "vertical-middle",
    align: "center",
  },
  {
    title: "Ngày Sinh",
    dataIndex: "birthday",
    key: "birthday",
    className: "vertical-middle",
    align: "center",
    width: 100,
    render: (value, item, index) =>
      moment(value, "YYYY-MM-DD").format("DD/MM/YYYY"),
  },
  {
    title: "Số Điện Thoại",
    dataIndex: "numberphone",
    key: "numberphone",
    className: "vertical-middle",
    align: "center",
    width: 120,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    className: "vertical-middle",
    align: "center",
  },
  {
    title: "Thời gian PV",
    dataIndex: "day_start",
    key: "day_start",
    className: "vertical-middle",
    align: "center",
    width: 150,
    render: (value, item) =>
      user_handling_permission.includes("can_hr_rec") ? (
        <TimePicker
          format={"HH:mm"}
          allowClear={true}
          defaultValue={
            item.data_interview_cv
              ? moment(item.data_interview_cv.time_start, "HH:mm:ss")
              : null
          }
          onChange={(e) => handleOKTimeCV(e, item, dataViewInverview)}
        />
      ) : item.data_interview_cv ? (
        `${moment(item.data_interview_cv.time_start, "HH:mm:ss").format(
          "HH:mm"
        )}`
      ) : null,
  },
  {
    title: "Trạng Thái CV",
    dataIndex: "cv_status__name",
    key: "cv_status__name",
    className: "vertical-middle",
    align: "center",
    width: 150,
    render: (value, item) => (
      <span
        className="btnStatus-disable"
        style={{
          backgroundColor: item.cv_status__color,
        }}
      >
        {value}
      </span>
    ),
  },
  {
    title: "Ngày Tạo CV",
    dataIndex: "created",
    key: "created",
    className: "vertical-middle",
    align: "center",
    width: 140,
    render: (value, item, index) => moment(value).format("DD/MM/YYYY HH:mm"),
  },
  {
    title: "Thao Tác",
    key: "action",
    className: "vertical-middle",
    align: "center",
    render: (_, record) => (
      <Space size="middle">
        <EyeOutlined
          onClick={() => handleClickOpenEdit(record.id)}
          className="styleIcon"
          title="Chi tiết"
        />
      </Space>
    ),
  },
];

const index = () => {
  const [form] = Form.useForm();
  const [form_filter] = Form.useForm();
  const [dataViewInverview, setDataViewInverview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listUser, setListUser] = useState([]);
  const { codeInterview } = useParams(); // Lấy codeInterview từ URL
  const [boolRole, setBoolRole] = useState(true);
  const [isModalOpenEditCandidate, setIsModalOpenEditCandidate] =
    useState(false);
  const [dataDetailCandidate, setDataDetailCandidate] = useState([]);
  const [typeEditForm, setTypeEditForm] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalDelCVInterview, setIsModalDelCVInterview] = useState(false);
  const ls_cv_status = useSelector((state) => state.user.ls_cv_status);
  const ls_city = useSelector((state) => state.user.ls_city);
  const [uploadFileCV, setUploadFileCV] = useState(null);
  const [uploadFileNote, setUploadFileNote] = useState(null);

  const user_handling_permission = useSelector((state) =>
    Object.values(state.user.handlingPermission).flat()
  );

  const fetchDetailInterview = (code, params) => {
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(url_get_detail_interview(code), { params })
      .then((res) => {
        setDataViewInverview(res.data);
        setListUser(res.data[0].data_user_interview);
        setLoading(false);
        setBoolRole(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        setLoading(false);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
            if (err.data.message.includes("Không có quyền truy cập")) {
              setBoolRole(false);
            }
          }
        }
      });
  };

  const fetchDetailCV = (params, setIsModalOpen) => {
    authAxios(cookies.get("token"))
      .get(url_get_detail_cv(params))
      .then((res) => {
        setDataDetailCandidate(res.data.results);
        setIsModalOpen(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  useEffect(() => {
    fetchDetailInterview(codeInterview);
  }, [codeInterview]);

  useEffect(() => {
    if (dataViewInverview.length != 0) {
      form.setFieldsValue({
        start_date: moment(dataViewInverview[0].start_date),
        time_start: moment(
          `${dataViewInverview[0].start_date}T${dataViewInverview[0].time_start}`
        ),
        time_end: moment(
          `${dataViewInverview[0].start_date}T${dataViewInverview[0].time_end}`
        ),
        // title: dataViewInverview[0].title,
        user_interview: dataViewInverview[0].data_user_interview.map(
          (item) => item.id
        ),
        note: dataViewInverview[0].note,
      });
    }
  }, [dataViewInverview, listUser]);

  const handleClickOpenEdit = (record) => {
    fetchDetailCV(record, setIsModalOpenEditCandidate);
    setTypeEditForm(false); // Dùng cùng 1 form chỉnh sửa hồ sơ của page QLUV nên thêm type view (chỉ đc xem)
  };

  const onFinish = (values) => {
    // Chức năng tìm kiếm
    fetchDetailInterview(codeInterview, {
      search: values.search,
      gender: values.gender,
      cv_status: values.cv_status,
    });
  };

  const onFinishDeleteMeeting = (values) => {
    if (selectedRowKeys.length == 0) {
      openNotificationWithIcon("error", "Vui lòng chọn CV.", "");
      return;
    }
    let params = {
      ls_id_cv: JSON.stringify(selectedRowKeys),
      code_interview: codeInterview,
    };
    let get_form = form_filter.getFieldsValue();
    authAxios(cookies.get("token"))
      .delete(url_del_cv_interview, { params })
      .then((res) => {
        openNotificationWithIcon("success", "Xóa thành công", "");
        setIsModalDelCVInterview(false);

        fetchDetailInterview(codeInterview, {
          search: get_form["search"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
        });
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.data.hasOwnProperty("message")) {
          openNotificationWithIcon("error", err.data.message, "");
        }
      });
  };

  const onFinishEdit = (values) => {
    // View CV Phỏng vấn | lưu ghi chú
    var FormData = require("form-data");
    var data = new FormData();
    data.append("id_cv", dataDetailCandidate.id);
    data.append("values", JSON.stringify(values));
    if (uploadFileNote != undefined) {
      data.append("file_note", uploadFileNote[0].originFileObj);
    }
    let get_form = form_filter.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_add_note_cv, data)
      .then((res) => {
        openNotificationWithIcon("success", "Lưu thông tin thành công", "");
        fetchDetailInterview(codeInterview, {
          search: get_form["search"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
        });
        setIsModalOpenEditCandidate(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
      });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDeleteCVInterview = () => {
    setIsModalDelCVInterview(true);
  };

  const handleChangeUploadNote = (info) => {
    if (info.fileList.length === 0) {
      setUploadFileNote(null);
    } else {
      setUploadFileNote(info.fileList);
    }
  };

  const handleOKTimeCV = (time_interview, record, dataViewInverview) => {
    let get_form = form_filter.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_detail_cv_interview, {
        id_interview: dataViewInverview[0].id,
        id_cv: record.id,
        time_start: time_interview ? time_interview.format("HH:mm") : null,
        // time_end: time_interview ? time_interview[1].format("HH:mm") : null,
      })
      .then((res) => {
        openNotificationWithIcon("success", "Đặt giờ phỏng vấn thành công", "");
        setIsModalDelCVInterview(false);

        fetchDetailInterview(codeInterview, {
          search: get_form["search"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
        });
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.data.hasOwnProperty("message")) {
          openNotificationWithIcon("error", err.data.message, "");
        }
      });
  };

  const columns = getColumns(
    dataViewInverview,
    handleClickOpenEdit,
    user_handling_permission,
    handleOKTimeCV
  );

  return boolRole == true ? (
    <div>
      <Row gutter={16}>
        <Col span={16}>
          <Card
            title={`Lịch phỏng vấn:  ${
              dataViewInverview.length !== 0 && dataViewInverview[0].title
            }`}
            className="mb-2"
            bodyStyle={{ padding: "16px" }}
            headStyle={{ padding: "0 16px" }}
          >
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={8}>
                <Col span={5}>
                  <Form.Item
                    label="Ngày phỏng vấn"
                    name="start_date"
                    className="detail-interview-form"
                  >
                    <DatePicker
                      format={dateFormat}
                      placeholder="DD/MM/YYYY"
                      disabled
                      suffixIcon={false}
                      className="disabled-option-interview"
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Giờ bắt đầu"
                    name="time_start"
                    className="detail-interview-form"
                  >
                    <TimePicker
                      hideDisabledOptions={true}
                      showNow={false}
                      allowClear={true}
                      autoFocus={true}
                      inputReadOnly={true}
                      minuteStep={5}
                      disabled={true}
                      format={"HH:mm"}
                      className="disabled-option-interview"
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Giờ kết thúc"
                    name="time_end"
                    className="detail-interview-form "
                  >
                    <TimePicker
                      hideDisabledOptions={true}
                      showNow={false}
                      allowClear={true}
                      autoFocus={true}
                      inputReadOnly={true}
                      minuteStep={5}
                      disabled={true}
                      format={"HH:mm"}
                      className="disabled-option-interview"
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item
                    label="Người phỏng vấn"
                    name="user_interview"
                    className="detail-interview-form "
                  >
                    <Select showSearch mode="multiple" maxTagCount={5}>
                      {listUser != undefined &&
                        listUser.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            disabled
                            className="disabled-option-interview"
                          >
                            {item.username}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col span={6}>
                  <Form.Item
                    label="Tiêu đề"
                    name="title"
                    className="detail-interview-form "
                  >
                    <Input
                      disabled
                      className="disabled-option-interview"
                      placeholder="Tiêu đề đặt lịch"
                    />
                  </Form.Item>
                </Col> */}
                <Col span={24}>
                  <Form.Item
                    label="Ghi chú lịch phỏng vấn"
                    name="note"
                    className="detail-interview-form"
                  >
                    <Input.TextArea
                      autoSize={{ minRows: 2 }}
                      maxLength={255}
                      disabled
                      className="disabled-option-interview"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>

        <Col span={8}>
          <Card
            title="Tìm kiếm ứng viên"
            bodyStyle={{ padding: "16px" }}
            headStyle={{ padding: "0 16px" }}
          >
            <Form
              form={form_filter}
              layout="vertical"
              autoComplete="off"
              onFinish={onFinish}
              initialValues={{
                remember: true,
              }}
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Tên/SĐT ứng viên"
                    name="search"
                    className="detail-interview-form"
                  >
                    <Input placeholder="Nhập Họ tên / Số điện thoại" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Giới tính"
                    name="gender"
                    className="detail-interview-form"
                  >
                    <Select allowClear placeholder="Chọn giới tính">
                      <Select.Option value="Nam">Nam</Select.Option>
                      <Select.Option value="Nữ">Nữ</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Trạng thái CV"
                    name="cv_status"
                    className="detail-interview-form"
                  >
                    <Select allowClear placeholder="Trạng thái hồ sơ">
                      {ls_cv_status.map((status) => (
                        <Select.Option key={status.id} value={status.id}>
                          {status.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24} style={{ textAlign: "center" }}>
                  <Form.Item
                    className="detail-interview-form"
                    style={{ marginBottom: 0 }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="detail-interview-button big-icon"
                    >
                      <SearchOutlined /> Tìm kiếm
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>

      <Row className="cadidate-management-row">
        {user_handling_permission.includes("can_hr_rec") && (
          <div
            className="detail-interview-form mb-2"
            style={{ width: "50%", display: "inline-block" }}
          >
            <Button
              danger
              type="primary"
              className="detail-interview-button big-icon"
              onClick={handleDeleteCVInterview}
              title="Xóa các CV trong lịch phỏng vấn"
            >
              <UserDeleteOutlined />
              Xóa CV phỏng vấn
            </Button>
          </div>
        )}
        <Table
          className="cadidate-management-table"
          columns={columns}
          dataSource={
            dataViewInverview[0] != undefined &&
            dataViewInverview[0].ls_cv_interview
          }
          loading={loading}
          pagination={false}
          scroll={{
            x: "max-content", // Kích thước ngang tự động điều chỉnh theo nội dung cột
            y: 550, // Chiều cao tối đa có thể lăn (thay số này để phù hợp với màn hình)
          }}
          rowKey="id" // Xác định khoá là `id`
          rowSelection={rowSelection}
        />
      </Row>

      {isModalOpenEditCandidate && (
        <ModalEditCandidate
          typeEditForm={typeEditForm}
          isModalOpenEditCandidate={isModalOpenEditCandidate}
          setIsModalOpenEditCandidate={setIsModalOpenEditCandidate}
          dataDetailCandidate={dataDetailCandidate}
          ls_city={ls_city}
          listEducationLevel={[]}
          listCandidateSource={[]}
          handleChangeUploadCV={[]}
          uploadFileCV={uploadFileCV}
          setUploadFileCV={setUploadFileCV}
          onFinishEdit={onFinishEdit}
          listStatusCV={ls_cv_status}
          onDeleleFileCV={[]}
          handleChangeUploadNote={handleChangeUploadNote}
          setUploadFileNote={setUploadFileNote}
        />
      )}
      {isModalDelCVInterview && (
        <ModalDeleteCVInterview
          isModalDelCVInterview={isModalDelCVInterview}
          setIsModalDelCVInterview={setIsModalDelCVInterview}
          onFinishDeleteMeeting={onFinishDeleteMeeting}
        />
      )}
    </div>
  ) : (
    <div>
      <NotPermission />
    </div>
  );
};

export default index;
